import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingSpinner = ({ 
  message = "Loading...", 
  size = 48, 
  thickness = 4, 
  color = "primary",
  minHeight = "200px",
  variant = "default" // "default" | "overlay"
}) => {
  return (
    <Box sx={{
      p: 4,
      height: '100%',
      minHeight: minHeight,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
        ...(variant === "overlay" && {
          position: "absolute",
          top: 0,
          left: 0,
          width:"100%",
          backdropFilter: "blur(6px)",
          WebkitBackdropFilter: "blur(6px)",
          zIndex: 1200,
        }),
      }}
    >
      <CircularProgress 
        size={size} 
        thickness={thickness} 
        color={color} 
      />
      <Typography 
        sx={{ 
          mt: 3, 
          color: 'text.secondary',
          fontSize: { xl: '18px', md: '14px' },
          fontWeight: 500
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingSpinner;
